<div class="card">
  <p-table
    #dt
    [value]="users"
    [paginator]="true"
    [lazy]="true"
    [rows]="pageSize"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    responsiveLayout="scroll"
    [rowsPerPageOptions]="[5, 10, 50, 100]"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [sortMode]="'multiple'"
    (onSort)="customSort($event)"
    (onPage)="onPage($event)"
    dataKey="id"
    [rowHover]="true"
    [globalFilterFields]="['firstName', 'lastName', 'userName', 'email', 'subscriptionStatus', 'planType']"
    >
    <ng-template pTemplate="caption">
      <div class="flex justify-content-between align-items-center">
        <div class="flex align-items-center">
          <span class="mr-2">Users List</span>
          <span class="p-input-icon-left ml-4">
            <i class="pi pi-search"></i>
            <input
              #searchInput
              id="search-user-input"
              type="text"
              pInputText
              placeholder="Search users..."
              [(ngModel)]="searchValue"
              (ngModelChange)="onSearchInput($event)" />
          </span>
        </div>
        <button
          id="refresh-users-btn"
          pButton pRipple
          class="p-button-secondary p-button-rounded"
          icon="pi pi-refresh"
          pTooltip="Refresh Users"
          (click)="refreshUsers(true)"></button>
      </div>
    </ng-template>

  <ng-template pTemplate="header">
    <tr class="sticky-header">
      <th style="width: 3rem"></th>
      <th style="width: 15%" id="firstNameHeader" pSortableColumn="firstName">First Name</th>
      <th style="width: 15%" id="lastNameHeader" pSortableColumn="lastName">Last Name</th>
      <th style="width: 12%" id="userNameHeader" pSortableColumn="userName">Username</th>
      <th style="width: 18%" id="emailHeader" pSortableColumn="email">Email</th>
      <th style="width: 12%" id="subscriptionStatusHeader" pSortableColumn="subscriptionStatus">Status</th>
      <th style="width: 10%" id="planTypeHeader" pSortableColumn="planType">Plan</th>
      <th style="width: 12%" id="subscriptionEndDateHeader" pSortableColumn="subscriptionEndDate">End Date</th>
      <th style="width: 6rem" class="text-center">Actions</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-user let-expanded="expanded">
    <tr *ngIf="!loading" class="fade-in">
      <td>
        <button
          id="expandUserRowButton_{{user?.id}}"
          type="button"
          pButton
          pRipple
          [pRowToggler]="user"
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          (click)="toggleRowExpansion(user)"
          pTooltip="{{expanded ? 'Collapse' : 'Expand'}} Details">
        </button>
      </td>
      <td>{{ user.firstName }}</td>
      <td>{{ user.lastName }}</td>
      <td>{{ user.userName || '-' }}</td>
      <td>
        <div class="flex align-items-center">
          <span [ngClass]="{'text-gray-400': !user?.email}">
            {{ user?.email || 'No email available' }}
          </span>
          <button
            *ngIf="user?.email"
            pButton
            pRipple
            icon="pi pi-copy"
            class="p-button-text p-button-sm"
            (click)="copyToClipboard(user?.email, $event)"
            pTooltip="Copy Email">
          </button>
        </div>
      </td>
      <td>
        <span class="status-badge" [ngClass]="getStatusClass(user.subscriptionStatus)">
          {{ user.subscriptionStatus || '-' }}
        </span>
      </td>
      <td>{{ user.planType || '-' }}</td>
      <td>{{ user.subscriptionEndDate ? (user.subscriptionEndDate | date: 'shortDate') : '-' }}</td>
      <td class="text-center">
        <button
          id="deleteUserButton_{{user?.id}}"
          type="button"
          pButton
          pRipple
          icon="pi pi-trash"
          class="p-button-text p-button-sm p-button-danger"
          tooltipPosition="left"
          pTooltip="Delete User"
          (click)="openDeleteModal(user)">
        </button>
      </td>
    </tr>
  </ng-template>

<ng-template pTemplate="rowexpansion" let-user>
  <tr>
    <td colspan="9">
      <div *ngIf="user.loading" class="p-4 text-center">
        <p-progressSpinner></p-progressSpinner>
        <p>Loading user details...</p>
      </div>
      <div *ngIf="!user.loading && user.details" class="grid card billing-details-container">
        <div class="col-12 md:col-4">
          <div class="card flex justify-content-center">
            <p-accordion [activeIndex]="0">
              <p-accordionTab id="userDetailsAccordion_{{user?.id}}" header="User Details">
                <ul class="list-none p-0 m-0">
                  <li class="flex align-items-center mb-2">
                    <div>
                      <span class="text-900 font-medium mr-2 mb-1 md:mb-0"><b>ID:</b></span>
                      <div class="mt-1 text-600"><i>{{ user.id || 'Not set' }}</i></div>
                    </div>
                  </li>
                  <li class="flex align-items-center mb-2">
                    <div>
                      <span class="text-900 font-medium mr-2 mb-1 md:mb-0"><b>Billing ID:</b></span>
                      <div class="mt-1 text-600"><i>{{ user.billingId || 'Not set' }}</i></div>
                    </div>
                  </li>
                  <li class="flex align-items-center mb-2">
                    <div>
                      <span class="text-900 font-medium mr-2 mb-1 md:mb-0"><b>Subscription ID:</b></span>
                      <div class="mt-1 text-600"><i>{{ user.subscriptionId || 'Not set' }}</i></div>
                    </div>
                  </li>
                  <li class="flex align-items-center mb-2">
                    <div>
                      <span class="text-900 font-medium mr-2 mb-1 md:mb-0"><b>Payment Method ID:</b></span>
                      <div class="mt-1 text-600"><i>{{ user.paymentMethodId || 'Not set' }}</i></div>
                    </div>
                  </li>
                  <li class="flex align-items-center mb-2">
                    <div>
                      <span class="text-900 font-medium mr-2 mb-1 md:mb-0"><b>To Remove:</b></span>
                      <div class="mt-1 text-600"><i>{{ yesNo(user.toRemove) }}</i></div>
                    </div>
                  </li>
                  <li class="flex align-items-center mb-2">
                    <div>
                      <span class="text-900 font-medium mr-2 mb-1 md:mb-0"><b>Free Trial:</b></span>
                      <div class="mt-1 text-600"><i>{{ yesNo(user.freeTrial) }}</i></div>
                    </div>
                  </li>
                  <li class="flex align-items-center mb-2">
                    <div>
                      <span class="text-900 font-medium mr-2 mb-1 md:mb-0"><b>Time Zone:</b></span>
                      <div class="mt-1 text-600"><i>{{ user.timeZone || 'Not set' }}</i></div>
                    </div>
                  </li>
                </ul>
              </p-accordionTab>
            </p-accordion>
          </div>
        </div>
        <div class="col-12 md:col-8">
            <p-fieldset legend="Billing Details" class="w-full">
              <ng-container *ngIf="user?.billingDetails?.length; else noBilling">
                <p-accordion id="billingAccordion_{{user?.id}}" [multiple]="true" styleClass="billing-accordion">
                  <p-accordionTab id="billingItem_{{user?.id}}_{{billing?.billingId}}" *ngFor="let billing of user.billingDetails; trackBy: billingTrackBy">
                    <ng-template pTemplate="header">
                      <span class="font-bold">{{ billing?.name + ': ' + (billing?.createdDate | date:'short') || 'Billing Item' }}</span>
                    </ng-template>
                    <div class="grid">
                      <div class="col-12 md:col-6 lg:col-4">
                        <span class="field-label"><b>Billing ID:</b></span>
                        <div class="field-value" [title]="billing?.billingId">{{ billing?.billingId || '—' }}</div>
                      </div>
                      <div class="col-12 md:col-6 lg:col-4">
                        <span class="field-label"><b>Product ID:</b></span>
                        <div class="field-value" [title]="billing?.productId">{{ billing?.productId || '—' }}</div>
                      </div>
                      <div class="col-12 md:col-6 lg:col-4">
                        <span class="field-label"><b>Feature:</b></span>
                        <div class="field-value" [title]="billing?.feature">{{ billing?.feature || '—' }}</div>
                      </div>
                      <div class="col-12 md:col-6 lg:col-4">
                        <span class="field-label">Subscription Item:</span>
                        <div class="field-value" [title]="billing?.subscriptionItem">{{ billing?.subscriptionItem || '—' }}</div>
                      </div>
                      <div class="col-12 md:col-6 lg:col-4">
                        <span class="field-label"><b>Created Date:</b></span>
                        <div class="field-value">{{ billing?.createdDate | date:'short' }}</div>
                      </div>
                      <div class="col-12 md:col-6 lg:col-4">
                        <span class="field-label"><b>Modified Date:</b></span>
                        <div class="field-value">{{ billing?.modifiedDate | date:'short' }}</div>
                      </div>
                      <div class="col-12 md:col-6 lg:col-3">
                        <span class="field-label"><b>To Remove:</b></span>
                        <div class="field-value">{{ yesNo(billing?.toRemove) }}</div>
                      </div>
                    </div>
                  </p-accordionTab>
                </p-accordion>
              </ng-container>
              <ng-template #noBilling>
                <div class="p-3 text-center text-600">No billing data available</div>
              </ng-template>
            </p-fieldset>
        </div>
      </div>
    </td>
  </tr>
</ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="9" class="text-center text-gray-400">
        <div class="mt-3">
          <div *ngIf="loading; else noData">
            Loading users...
          </div>
          <ng-template #noData>
            No users found
          </ng-template>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
</div>

<!-- Hard Delete Confirmation Dialog -->
<p-dialog
  [(visible)]="showDeleteDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [style]="{width:'480px', maxWidth:'95vw'}"
  header="Confirm Hard Delete"
  styleClass="hard-delete-dialog"
  (onShow)="focusDeleteInput()"
>
  <div class="flex flex-column gap-3">
    <div class="flex gap-2 align-items-start hard-delete-banner">
      <i class="pi pi-exclamation-triangle text-2xl text-orange-500"></i>
      <div>
        <p class="m-0 font-medium">You are about to permanently delete this user.</p>
        <p class="m-0 text-600 text-sm line-height-3">The selected user (ID <code>{{userPendingDelete?.id}}</code>) will be removed from Stripe when present and deleted or deactivated in the local identity system according to retention rules. This action cannot be undone from the admin panel.</p>
      </div>
    </div>

    <div class="confirmation-input-group">
      <label for="deleteReasonInput" class="block text-sm font-medium mb-1">Reason or support ticket:</label>
      <textarea
        id="deleteReasonInput"
        pInputText
        rows="3"
        maxlength="500"
        [(ngModel)]="deletionReason"
        placeholder="Required for the admin audit record"
        class="w-full mb-3"></textarea>
      <label for="deleteConfirmInput" class="block text-sm font-medium mb-1">Type <strong>Delete</strong> to confirm:</label>
      <input
        id="deleteConfirmInput"
        #deleteInput
        pInputText
        type="text"
        autocomplete="off"
        [value]="deleteInputValue"
        (input)="onDeleteInput($event)"
        (keydown.enter)="canConfirmDelete() && confirmDelete()"
        placeholder="Delete"
        class="w-full"
      />
      <small class="p-error" *ngIf="deleteInputValue && deleteInputValue !== 'Delete' && !deleting">Value must exactly match 'Delete'.</small>
    </div>

    <div *ngIf="billingOwnerOrganizations.length" class="p-3 border-1 border-orange-300 border-round surface-50">
      <p class="mt-0 mb-2 font-medium text-orange-700">Billing ownership must be reassigned</p>
      <p class="mt-0 mb-3 text-sm line-height-3">
        This user owns {{billingOwnerOrganizations[0].name || ('organization #' + billingOwnerOrganizations[0].id)}}.
        Select an active member to take over billing ownership. The deletion will be retried only after the transfer succeeds.
      </p>
      <label for="replacementBillingOwner" class="block text-sm font-medium mb-1">New billing owner</label>
      <p-dropdown
        inputId="replacementBillingOwner"
        [options]="replacementMembers"
        [(ngModel)]="selectedReplacementUserId"
        optionValue="userId"
        [optionLabel]="'name'"
        placeholder="Select an active member"
        [emptyMessage]="'No eligible active members'"
        styleClass="w-full">
        <ng-template pTemplate="item" let-member>
          <span>{{member.name || member.email || member.userId}}</span>
        </ng-template>
        <ng-template pTemplate="selectedItem" let-member>
          <span>{{member?.name || member?.email || member?.userId}}</span>
        </ng-template>
      </p-dropdown>
      <small *ngIf="!replacementMembers.length" class="block p-error mt-2">
        Add or activate another organization member before transferring billing ownership.
      </small>
      <button type="button" pButton class="mt-3" label="Transfer and Retry Deletion"
        icon="pi pi-arrow-right-arrow-left"
        [loading]="loadingReassignment"
        [disabled]="!selectedReplacementUserId || loadingReassignment"
        (click)="transferBillingOwnershipAndRetry()"></button>
    </div>

    <div class="flex justify-content-end gap-2 mt-2">
      <button type="button" pButton label="Cancel" class="p-button-text" (click)="closeDeleteDialog()"></button>
      <button *ngIf="!billingOwnerOrganizations.length" type="button" pButton label="Delete Permanently" icon="pi pi-trash" [disabled]="!canConfirmDelete() || deleting" class="p-button-danger" (click)="confirmDelete()"></button>
    </div>
  </div>
</p-dialog>
